import { render, staticRenderFns } from "./copyTag.vue?vue&type=template&id=3cc5ec4a"
import script from "./copyTag.vue?vue&type=script&lang=js"
export * from "./copyTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cc5ec4a')) {
      api.createRecord('3cc5ec4a', component.options)
    } else {
      api.reload('3cc5ec4a', component.options)
    }
    module.hot.accept("./copyTag.vue?vue&type=template&id=3cc5ec4a", function () {
      api.rerender('3cc5ec4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widget/copyTag.vue"
export default component.exports